import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeModeProvider } from './contexts/ThemeModeContext';
import { AuthProvider } from './contexts/AuthContext';
import { ChatProvider } from './contexts/ChatContext';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import ChatPage from './pages/ChatPage';
import DemoPage from './pages/DemoPage';
import MyTicketsPage from './pages/MyTicketsPage';
import TicketDetailPage from './pages/TicketDetailPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ProtectedRoute from './components/ProtectedRoute';
import RootRedirect from './components/RootRedirect';
import { KnowledgeBasePage } from './knowledge-base/pages/KnowledgeBasePage';
import { ArticlePage } from './knowledge-base/pages/ArticlePage';
import { SearchPage } from './knowledge-base/pages/SearchPage';
import DocumentBuilderPage from './pages/DocumentBuilder/DocumentBuilder';
import BusinessInfoPage from './pages/BusinessInfo/BuinessInfo';
import './App.css';

// Theme moved to ThemeModeProvider

function App() {
  return (
    <ThemeModeProvider>
      <AuthProvider>
        <ChatProvider>
          <Router future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}>
            <div className="App">
              <Routes>
                <Route path="/" element={<RootRedirect />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/change-password" element={<ChangePasswordPage />} />
                <Route path="/demo" element={<DemoPage />} />
                <Route path="/chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
                <Route path="/my-tickets" element={<ProtectedRoute><MyTicketsPage /></ProtectedRoute>} />
                <Route path="/ticket/:ticketId" element={<ProtectedRoute><TicketDetailPage /></ProtectedRoute>} />
                <Route path="/knowledge-base/category/:category" element={<KnowledgeBasePage />} />
                <Route path="/knowledge-base/article/:articleId" element={<ArticlePage />} />
                <Route path="/knowledge-base/search" element={<SearchPage />} />
                <Route path="/knowledge-base" element={<KnowledgeBasePage />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/document-builder" element={<ProtectedRoute><DocumentBuilderPage /></ProtectedRoute>} />
                <Route path="/business-info" element={<ProtectedRoute><BusinessInfoPage /></ProtectedRoute>} />
              </Routes>
            </div>
          </Router>
        </ChatProvider>
      </AuthProvider>
    </ThemeModeProvider>
  );
}

export default App;
